module.exports = __webpack_public_path__ + "img/infos.14129e91.svg";